import { ACTION_TYPES } from '../../../utils/Constants';
import { myLog } from '../../../utils/Utility';
import Client from '../../../utils/ClientVOIM';
import URL from '../../../utils/URL';
import { RESPONSE_CONSTANT } from '../../../utils/ResponseConstant';

export function getStudentSessionList(sort, date, pageNumber, itemsPerPage, callBack) {
    return function (dispatch) {
        let values = {
            sort,
            date,
            pageNumber,
            itemsPerPage,
        };
        Client.get(URL.IM_STUDENT.GET_STUDENTS_SESSION_LIST, values, true)
            .then((response) => {
                myLog('====getStudentSessionList response  ./      ===::::', response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====getStudentSessionList error===????', error);
                callBack(false);
            });
    };
}

export const getSubjectList = (values, callBack) => {
    return function (dispatch) {
        Client.get(URL.COMMON_ENDPOINT.GET_SUBJECT, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.STUDENT.GET_SUBJECT_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====Subject error===????', error);
                callBack(false);
            });
    };
};
export const getSubCategoryList = (subjectId, values, callBack) => {
    return function (dispatch) {
        Client.get(`${URL.COMMON_ENDPOINT.GET_SUB_CATEGORY}/${subjectId}`, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.STUDENT.GET_SUBCATEGORY_LIST,
                        payload: response.response.data,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
            });
    };
};

export const getEducatorList = (sessionType, values, callBack) => {
    return function (dispatch) {
        Client.get(
            `${URL.IM_STUDENT.GET_EDUCATOR_LIST}/category?sessionType=${sessionType}`,
            values,
            true
        )
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.STUDENT.GET_EDUCATOR_LIST,
                        payload: response.response.data,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
            });
    };
};

export const getEducatorAvailablityDays = (educatorId, callBack) => {
    return function (dispatch) {
        Client.get(
            `${URL.COMMON_ENDPOINT.GET_EDUCATOR_AVAILABILITY_DAYS}?id=${educatorId}`,
            {},
            true
        )
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====Subject error===????', error);
                callBack(false);
            });
    };
};

export const getEducatorAvailability = (educator, date, callBack) => {
    return function (dispatch) {
        Client.get(
            `${URL.IM_STUDENT.GET_EDUCATOR_AVAILABILITY}/${educator}/date/${date}`,
            null,
            true
        )
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.STUDENT.GET_EDUCATOR_AVAILABILITY,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                if (typeof callBack === 'function') {
                    callBack(false);
                }
            });
    };
};

export const postOndemandAppointment = (values, callBack) => {
    return function (dispatch) {
        Client.post(URL.IM_STUDENT.POST_ONDEMAND, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.STUDENT.POST_ONDEMAND,
                        payload: response,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
            });
    };
};

export const getAllEducatorList = (values, callBack) => {
    return function (dispatch) {
        Client.get(URL.IM_STUDENT.EDUCATOR_LIST_FOR_CHAT, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.STUDENT.GET_SUBJECT_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====Subject error===????', error);
                callBack(false);
            });
    };
};

export const getPreviousEducatorList = (values, callBack) => {
    return function (dispatch) {
        Client.get(URL.IM_STUDENT.EDUCATOR_PREVIOUS_LIST_FOR, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.STUDENT.GET_SUBJECT_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====Subject error===????', error);
                callBack(false);
            });
    };
};

export const getEducatorChatList = (id, values, callBack) => {
    return function (dispatch) {
        Client.get(
            `${URL.IM_STUDENT.GET_EDUCATOR_CHAT_LIST}?receiverUserId=${id}&isFile=${false}`,
            values,
            true
        )
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.EDUCATOR.GET_SUBJECT_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====Subject error===????', error);
                callBack(false);
            });
    };
};

export const getStudentFileUpload = (values, callBack) => {
    return function (dispatch) {
        Client.post(URL.IM_STUDENT.GET_STUDENT_FILE_UPLOAD, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.EDUCATOR.GET_SUBJECT_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====Subject error===????', error);
                callBack(false);
            });
    };
};

export const getStudentFileDownload = (fileId, values, callBack) => {
    return function (dispatch) {
        Client.get(`${URL.IM_STUDENT.GET_STUDENT_FILE_DOWNLOAD}?fileId=${fileId}`, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.EDUCATOR.GET_SUBJECT_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====Subject error===????', error);
                callBack(false);
            });
    };
};

export const getUnreadPreviousUserList = (values, callBack) => {
    return function (dispatch) {
        // const values = {
        //   search,
        //   pageNumber,
        //   itemsPerPage,
        // };
        Client.get(URL.IM_STUDENT.GET_UNREAD_PREVIOUS_USER_LIST, values, true)
            .then((response) => {
                myLog('====Subject response===????', response);

                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.STUDENT.GET_UNREAD_PREVIOUS_USER_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====Subject error===????', error);
                if (typeof callBack === 'function') {
                    callBack(false);
                }
            });
    };
};

export function getAllSessions(sort, date, pageNumber, itemsPerPage, callBack) {
    return function (dispatch) {
        let values = {
            sort,
            date,
            pageNumber,
            itemsPerPage,
        };
        Client.get(URL.GET_ALL_SESSION_LIST, values, true)
            .then((response) => {
                myLog('====getStudentSessionList response  ./      ===::::', response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====getStudentSessionList error===????', error);
                callBack(false);
            });
    };
}

export const getChatMessageHistory = (values, callBack) => {
    return function (dispatch) {
        Client.get(URL.IM_STUDENT.GET_ALL_CHAT_HISTORY, { ...values, isFile: false }, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.CHAT.GET_CHAT_MESSAGE_HISTORY,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====Chat Message History error===????', error);
                callBack(false);
            });
    };
};
